export const convertEmployee = (data) => {
    let converted = [];

    if (!data) return [];

    data.forEach((item, index) => {
        converted.push({
            label: `${item.first_name} ${item.last_name}`,
            value: item.id
        });
    });
    return converted;
};
